<template>
  <v-container class="view">
    <v-row justify="center" align="center" style="min-height:50vh">

      <v-col cols="12" sm="4">
        <h2 class="text-capitalize  mb-1 display-5 mt-3">Login</h2>
        <!------------------------show login error or ask user to login----------------->
        <p class="text--secondary mb-7 mt-n1">Login to get started</p>
        <small v-if="showLoginError" class="red--text lighten-3 d-block mb-3 mt-n3  text-center"
          v-html="authError"></small>
        <v-spacer></v-spacer>

        <!-----------display  none for social--------->
        <div class="d-none">
          <!--------------social login change d-none to d-flex------------>
          <div class="justify-space-between align-center mb-10 d-flex">
            <v-btn elevation="0" class="elevation-0" outlined color="#dd4b39">
              <span class="d-sr-only">log in with google</span>
              <v-icon color="#dd4b39">mdi-google</v-icon>
            </v-btn>

            <v-btn elevation="0" class="-2" color="#3b5998" outlined>
              <span class="d-sr-only">log in with facebook</span>
              <v-icon color="#3b5998">mdi-facebook</v-icon>
            </v-btn>

            <v-btn outlined elevation="0" color="#2196f3">
              <span class="d-sr-only">log in with twitter</span>
              <v-icon color="#2196f3">mdi-twitter</v-icon>
            </v-btn>
          </div>
          <small class="social sub-hero-text  text-small text-center">
            or continue with email</small>
        </div>

        <!--------------login form ----------------->
        <v-form v-model="valid" @submit.prevent="submit" lazy-validation ref="form">
          <v-text-field  v-model="credentials.email" :rules="emailValidationRules" label="E-mail"
            placeholder="example@mailer.com" required outlined></v-text-field>

          <v-text-field class="m-0 p-0" autocomplete="current-password" :value="userPassword" label="Enter password"
            outlined required v-model="credentials.password" :append-icon="value ? 'mdi-eye' : 'mdi-eye-off'"
            @click:append="() => (value = !value)" :type="value ? 'password' : 'text'" :rules="passwordValidationRules"
            @input="(_) => (userPassword = _)"></v-text-field>

          <!----------------login button--------------------->
          <v-btn block type="submit" class="white--text" large color="var(--purple)" :loading="loading"
            :disabled="loading">
            Login
          </v-btn>

          <!-----------------------back to sign up and forgotten password -------------------->
          <small class="text-normal grey-text pt-2 d-block mt-4">
            don&apos;t have an account?
            <router-link :to="{ name: 'email-sign-up' }">Sign up </router-link>
          </small>
          <small class="text-small">
            <router-link :to="{ name: 'confirm-email' }">forgotten password?
            </router-link>
          </small>
        </v-form>
        <v-spacer></v-spacer>

      </v-col>
    </v-row>
  </v-container>
</template>

<script>
//import store to be able to get username or id and then set it to router params
import store from "@/store";

//import login method from central store
import { mapActions, mapGetters } from "vuex";

export default {
  data: () => ({
    //login credentials
    credentials: {
      email: "",
      password: "",
    },
    valid: false,
    loading: false, //for loader
    showLoginError: false,
    authError: "",
    emailValidationRules: [
      (v) => !!v || "E-mail is required",
      (v) => /.+@.+/.test(v) || "E-mail must be valid",
    ],
    //if password length is zero
    passwordValidationRules: [
      (v) => v.length > 0 || "Password must be provided",
    ],
    userPassword: "",
    value: true,
  }),

  methods: {
    //destructure the login action imported from central store into login method into local login method, take caution both method don't have same name to avoid issues
    ...mapActions({
      login: "auth/login",
    }),
    submit() {
      //first check if the form is valid, if not give error
      if (!this.$refs.form.validate()) {
        this.loading = false;
      }

      //else show loading action send credentials to server
      else {
        this.loading = true;
        this.login(this.credentials).then(() => {
          //if login error stop loading action, then show the error
          if (this.loginError) {
            this.loading = false;
            this.showLoginError = true;
            this.authError = this.loginError;
          }

          //if the user is authenticated and his data exists
          if (this.authenticated) {
            this.loading = false;
            //get username and id from central store and add it as router params
            const { user_id, username } = this.current_user;
            //if the username has not been set, use  truncated user_id as router params
            const current_user_id = username ? username : user_id;
            //go on to user dashboard (the default child route of user account) if no authentication error
            this.$router.replace({
              name: "dashboard",
              params: { user: current_user_id },
            });
          }
        });

        //clean up the login error message
        this.showLoginError = false;
      }
    },
  },
  computed: {
    ...mapGetters({
      authenticated: "auth/authenticated",
      current_user: "auth/user",
    }),

    //parse login error here
    loginError() {
      return store.getters["auth/authenticationError"];
    },
  },
};
</script>

<style scoped>
.social {
  margin: 0.5rem 0;
  display: flex;
  justify-content: space-between;
  align-content: center;
  font-size: 85%;
}

.social+div+p.sub-hero-text {
  margin: 1.5rem 0 1.2rem;
  color: var(--grey);
  display: block;
  font-size: 14px;
}

.social::before,
.social::after {
  content: "\00A0\00A0\00A0\00A0\2014\2014\2014\2014\2014\2014\2014\00A0\00A0\00A0\00A0";
  letter-spacing: -2.5px;
  color: var(--grey);
  opacity: 0.5;
}
</style>